import {inject, Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';

@Injectable()

export class PlutonInvoicingModuleService {

  private _httpClient = inject(HttpClient);
  private _url = environment.apiConfig.corporateAPI.endpoint;

  get<T>(path: string, options?: {}): Observable<T> {
    return this._httpClient.get<T>(this._url +path, options);
  }

  post<T, R>(path: string, data: T, options?: {}): Observable<R> {
    return this._httpClient.post<R>(this._url + path, data, options);
  }

  patch<T, R>(path: string, data?: T, options?: {}): Observable<R> {
    return this._httpClient.patch<R>(this._url + path, data, options);
  }

  put<T, R>(path: string, data: T, options?: {}): Observable<R> {
    return this._httpClient.put<R>(this._url + path, data, options);
  }

  delete<T>(path: string, options?: {}): Observable<T> {
    return this._httpClient.delete<T>(this._url + path, options);
  }
}
